import {Component, ElementRef, forwardRef, HostBinding, Injector} from '@angular/core';
import {AbstractInput} from '../abstract-input';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EmailInputComponent)
        }
    ],
    selector: 'vui-email-input',
    templateUrl: './email-input.component.html',
    styleUrls: ['./email-input.component.scss']
})
export class EmailInputComponent extends AbstractInput {
    constructor(protected injector: Injector) {
        super(injector);
    }
}
